<template>
  <div class="modal-body">
    <div style="position: relative">
      <el-page-header
        @back="goBack"
        :content="showChart1 ? '事业部培训场次统计' : '事业部培训人次统计'"
      ></el-page-header>
      <div class="btn" @click="isShow = !isShow">
        <i
          size="mini"
          class="filter_style"
          style="color: #fff"
          :class="isShow == false ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          ><span>筛选</span></i
        >
      </div>
    </div>

    <div
      style="width: 100%; overflow: auto"
      :style="{ height: height + 'px' }"
      v-loading="chartLoading"
    >
      <div class="option" v-show="isShow">
        <el-form
          class="form-style"
          ref="params"
          :model="params"
          size="mini"
          label-width="70px"
        >
          <el-form-item label="开始日期" prop="BeginDate">
            <el-date-picker
              style="width: 120px"
              @change="
                (val) => {
                  changeBeginDate(val);
                }
              "
              v-model="BeginTime"
              type="month"
              format="yyyy年MM月"
              value-format="yyyy-MM"
              placeholder="开始日期"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期" prop="EndDate">
            <el-date-picker
              style="width: 120px"
              @change="
                (val) => {
                  changeEndDate(val);
                }
              "
              v-model="EndTime"
              type="month"
              format="yyyy年MM月"
              value-format="yyyy-MM"
              placeholder="结束日期"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="事业部" prop="College">
            <el-select
              v-model="params.College"
              placeholder="请选择事业部"
              style="width: 120px"
              @change="selectProject"
              clearable
            >
              <el-option
                v-for="item in Colleges"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="分线" prop="Branch">
            <el-select
              v-model="params.Branch"
              placeholder="请选择分线"
              style="width: 120px"
              @change="getQuery"
              clearable
            >
              <el-option
                v-for="item in productLine"
                :key="item.Id"
                :label="item.Name"
                :value="item.Name"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="类型" prop="TrainType" class="type_style">
          <el-select v-model="params.TrainType" placeholder="请选择类型" style="width: 120px;" @change='search'>
            <el-option v-for="(item,index) in typeList" :key="index" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item> -->
          <!-- <el-form-item label="类型" prop="TrainType">
          <el-select v-model="params.TrainType" @change="search">
            <el-option v-for="ev in typeList" :key="ev.Key" :label="ev.ParentName+'-'+ev.Name" :value="ev.Key">
            </el-option>
          </el-select>
        </el-form-item> -->

          <!-- <el-form-item label-width="0px">
          <div style="text-align: center;margin-top: 30px;">
            <el-button size="medium" type="primary" :loading="loadingsave" @click="saveplans">确认</el-button> 
          </div>
           
        </el-form-item> -->
        </el-form>
      </div>

      <div id="main1" style="width: 100%; min-height: 600px"></div>
      <div
        id="main3"
        style="width: 100%; min-height: 300px; margin-top: 30px"
      ></div>
    </div>
    <div class="radioBtn">
      <el-radio-group v-model="radio" size="small" @change="changeHandler">
        <el-radio-button label="人数"></el-radio-button>
        <el-radio-button label="场次"></el-radio-button>
      </el-radio-group>
    </div>

    <el-drawer title="筛选" :visible.sync="showDialog" @close="close">
    </el-drawer>
  </div>
</template>
<script>
import {
  getBaseUrl,
  GetFenLeiList,
  GetBDTrainKpi,
  GetEventOption,
} from "../../api/api";
import moment, { min } from "moment";
import echarts from "echarts";

export default {
  data() {
    return {
      eventOptions: [],
      baseUrl: getBaseUrl(),
      chartLoading: false,
      loadingsave: false,
      date: "2021年1月",
      height: 0,
      radio: "人数",
      showDialog: false,
      isShow: false,
      dataList: [],
      seriesList: [],
      DsRegionList: [],
      Colleges: [],
      DsTrainTypeList: [],
      searchModel: {
        StartTime: "",
        EndTime: "",
        SybId: "",
        CpxId: "",
        Type: "",
      },
      BeginTime: "",
      EndTime: "",
      params: {
        TrainerId: 0,
        BeginDate: "",
        EndDate: "",
        College: "",
        CollegeId: "",
        Branch: "",
        TrainType: "",
        SearchKey: "",
        Type: 1,
      },
      // typeList:[{name: '标准培训'},{name: '工作坊'},{name: '协防辅导'}],
      typeList: [],
      business: [],
      productLine: [],
      colors: [
        ["#4a7fb0", "#adc6e5", "#96bfee", "#60a0e8", "#96bfee", "#c6ccd4"],
        ["#2f75b5", "#348bee", "#96bfee", "#60a0e8", "#96bfee", "#c6ccd4"],
        ["#2f75b5", "#348bee", "#96bfee", "#60a0e8", "#96bfee", "#c6ccd4"],
      ],
      showChart1: false,

      proportion: [],

      total: [],
      total2: [],
    };
  },
  mounted() {
    this.height = window.innerHeight - 80;
    this.GetFenLeiList();
    // this.selectType()
    this.search();
  },
  methods: {
    search() {
      this.chartLoading = true;
      if (
        !this.params.BeginDate ||
        typeof this.params.BeginDate == "null" ||
        this.params.BeginDate.length < 7
      ) {
        this.params.BeginDate = "";
      }
      if (
        this.params.EndDate == null ||
        this.params.EndDate == undefined ||
        this.params.EndDate == "null"
      ) {
        this.params.EndDate = "";
      }
      // console.log("------this.params-----", this.params);
      GetBDTrainKpi(this.params).then((res) => {
        if (res.data.Code != 1) return;
        //console.log("i see", res.data.Data);
        if (res.data.Data.length == 0) {
          this.chartLoading = false;
          this.$message.error("无匹配数据！");
        }
        this.dataList = res.data.Data;
        this.seriesList = [];
        this.DsTrainTypeList = [];
        this.DsRegionList = [];
        this.proportion = [];
        this.dataList.forEach((e) => {
          if (this.DsTrainTypeList.indexOf(e.TrainType) < 0) {
            this.DsTrainTypeList.push(e.TrainType);
          }
          if (this.DsRegionList.indexOf(e.Region) < 0) {
            // console.log(e.Region);
            // var Region=e.Region.substring(e.Region.length-2);
            this.DsRegionList.push(e.Region);
          }
        });
        this.DsTrainTypeList.forEach((e) => {
          var arrDt = new Array(this.DsRegionList.length);
          var iCounts = 0;
          this.dataList.forEach((k) => {
            if (k.TrainType == e) {
              arrDt[this.DsRegionList.indexOf(k.Region)] = k.Value;
              iCounts += k.Value;
            }
          });
          this.seriesList.push({
            name: e,
            type: "bar",
            stack: "1",
            barGap: "-100%",
            data: arrDt,
            label: { show: true },
          });
          this.proportion.push({ value: iCounts, name: e });
        });
        setTimeout(() => {
          this.initChart();
          this.myChart3();
          this.chartLoading = false;
        }, 100);
      });
    },
    initChart() {
      var myChart = echarts.init(document.getElementById("main1"));
      var option = {
        color: this.showChart1 ? this.colors[3] : this.colors[0],
        backgroundColor: "transparent", //#344b58
        title: {
          // showChart1
          text: this.showChart1 ? "培训场次次统计" : "培训人次统计",
          left: "center",
          top: 10,
          textStyle: {
            color: "#000",
            fontSize: "16",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          borderWidth: 0,
          top: "12%",
          left: 20,
          width: "80%",
          height: "84%",
          textStyle: {
            color: "#fff",
          },
          containLabel: true,
        },
        legend: {
          left: "12%",
          top: 35,
          textStyle: {
            color: "#90979c",
          },
          // data: ['肿瘤', '影像', '综合','麻醉']
          data: this.DsTrainTypeList,
        },
        xAxis: {
          name: "人数",
          type: "value",
        },
        yAxis: {
          type: "category",
          data: this.DsRegionList,
          axisLabel: {
            formatter: function (value) {
              return 1 * value.substring(value.length - 2);
            },
          },
        },

        series: this.seriesList,
      };
      myChart.setOption(option, true);
    },

    myChart3() {
      var myChart3 = echarts.init(document.getElementById("main3"));
      var option = {
        color: this.showChart1 ? this.colors[5] : this.colors[2],
        title: {
          left: "center",
          top: 10,
          bottom: "10%",
          text: "总累计占比",
          textStyle: {
            color: "#000",
            fontSize: 16,
          },
        },
        label: {
          normal: {
            formatter: "{c}",
            position: "inside",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c}",
        },
        legend: {
          orient: "vertical",
          left: 20,
          top: "12%",
          data: this.DsTrainTypeList,
        },
        series: [
          {
            name: "总累计占比: ",
            type: "pie",
            top: 30,
            left: "10%",
            radius: "60%",
            labelLine: {
              show: false,
            },
            label: {
              position: "inner",
              show: true,
              // formatter:'{b} : \n{d}%',
              formatter: " \n{d}%",
              fontSize: 12,
            },
            // data: this.proportion2,
            // data:this.showChart1?this.total:this.total2,
            data: this.proportion,

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart3.setOption(option);
    },
    // 人数，场次切换
    changeHandler() {
      this.showChart1 = !this.showChart1;
      if (this.showChart1 == true) {
        this.params.Type = 2;
      } else {
        this.params.Type = 1;
      }
      setTimeout(() => {
        this.chartLoading = false;
        this.search();
      }, 1000);
    },
    myChart4() {
      var myChart = echarts.init(document.getElementById("main4"));
      var option = {
        color: this.showChart1 ? this.colors[3] : this.colors[0],
        backgroundColor: "transparent", //#344b58
        title: {
          // showChart1
          text: this.showChart1 ? "YTD培训场次次统计" : "YTD培训人次统计",
          left: "center",
          top: 10,
          textStyle: {
            color: "#000",
            fontSize: "16",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          borderWidth: 0,
          top: "30%",
          left: 20,
          // width: "80%",
          height: "70%",
          textStyle: {
            color: "#fff",
          },
          containLabel: true,
        },
        calculable: true,
        xAxis: {
          type: "category",
          data: [
            "艾瑞卡线中国北区",
            "艾瑞卡线中国南区",
            "艾瑞妮线",
            "艾坦线",
            "肿瘤综合线中国北区",
            "肿瘤综合线中国南区",
          ],
          // data:this.DsTrainTypeList,
          axisPointer: {
            type: "shadow",
          },
          axisLabel: { interval: 0, rotate: 30 },
        },
        yAxis: {
          type: "value",
          name: "人数",
          min: 0,
          axisLabel: {
            formatter: "{value}",
          },
        },
        series: [
          {
            name: this.showChart1 ? "培训场次数" : "培训人数",
            type: "bar",
            data: this.showChart1
              ? [52, 50, 45, 65, 76, 87, 65]
              : [54, 76, 45, 65, 87, 65, 45, 76],
            barWidth: 20,
            label: {
              show: true,
            },
          },
        ],
      };
      myChart.setOption(option);
    },

    showSearch() {
      this.showDialog = true;
      this.getFenLeiList();
    },
    // 事业部
    GetFenLeiList() {
      GetFenLeiList(-1).then((res) => {
        if (res.data.Code != 1) return;
        this.Colleges = res.data.Data;
      });
    },
    selectProject(val) {
      this.params.College = "";
      this.productLine = [];
      this.Colleges.forEach((e) => {
        if (e.Id == val) {
          this.params.College = e.Name;
        }
      });
      GetFenLeiList(val).then((res) => {
        if (res.data.Code != 1) return;
        this.productLine = res.data.Data;
      });
      this.params.Branch = "";
      this.search();
    },
    getQuery(val) {
      // this.params.College = ''
      this.search();
    },
    selectType() {
      GetEventOption().then((res) => {
        if (res.data.Code != 1) return;
        this.typeList = res.data.Data;
      });
    },
    // 类型
    // getFenLeiList(){
    //   GetFenLeiList(-1).then(res=>{
    //     if(res.data.Code != 1) return;
    //     this.typeList = res.data.Data;
    //   })
    // },
    filterHandler(value, row, column) {
      // console.log(value, row, column,'产品线');
      const property = column["property"];
      return row[property] === value;
    },

    // changeBeginDate(val) {
    //   var endTime = this.params.EndDate;
    //   var start;
    //   var end;
    //   if (val) {
    //     start = moment(new Date(val)).format("YYYY-MM"); //开始时间
    //   } else {
    //     start = "";
    //   }
    //   if (endTime) {
    //     end = moment(new Date(endTime)).format("YYYY-MM"); //结束时间
    //   }
    //   console.log(val, start, "start");
    //   if (start > end) {
    //     this.$message.error("开始日期不能大于结束日期");
    //     this.params.BeginDate = "";
    //     return;
    //   }
    //   this.search();
    // },
    changeBeginDate(val) {
      var endDate = this.EndTime;
      if (val) {
        var start = moment(new Date(val)).format("YYYY-MM"); //开始时间
        var end; //结束时间
        if (endDate) {
          end = moment(new Date(endDate)).format("YYYY-MM"); //结束时间
        }
        if (end && start > end) {
          this.$message.error("开始日期不能大于结束日期");
          this.params.BeginDate = "";
          return;
        }
        this.params.BeginDate = start;
        this.params.EndDate = end;
      } else {
        this.params.BeginDate = "";
      }
      this.search();
    },
    //
    changeEndDate(val) {
      var beginDate = this.BeginTime;
      if (val) {
        var end = moment(new Date(val)).format("YYYY-MM"); //开始时间
        if (beginDate) {
          var start = moment(new Date(beginDate)).format("YYYY-MM"); //结束时间
          if (end < start) {
            this.$message.error("结束日期不能小于开始日期");
            this.params.EndDate = "";
            return;
          }
        }
        this.params.BeginDate = start;
        this.params.EndDate = end;
      } else {
        this.params.EndDate = "";
      }
      this.search();
    },
    // changeEndDate(val) {
    //   var beginDate = this.params.BeginDate;
    //   var start;
    //   var end;
    //   if (val) {
    //     end = moment(new Date(val)).format("YYYY-MM"); //开始时间
    //   } else {
    //     end = "";
    //   }
    //   if (beginDate) {
    //     start = moment(new Date(beginDate)).format("YYYY-MM"); //结束时间
    //   }
    //   if (end < start) {
    //     this.$message.error("结束日期不能小于开始日期");
    //     this.params.EndDate = "";
    //     return;
    //   }
    //   this.search();
    // },
    saveplans() {
      //   this.loadingsave = true;
      this.showDialog = false;
      this.search();
      //   api(this.searchModel).then(res=>{
      //     this.loadingsave = false;
      //     if(res.data.Code != 1) return;
      //     this.showDialog = false;
      //   })
      this.close();
    },
    close() {
      this.searchModel = {
        // StartTime:'',
        // EndTime:'',
        // SybId:'',
        // CpxId:'',
        // Type:'',
      };
    },
    goBack() {
      window.history.go(-1);
      // try {
      //   console.log("调用方法 1");
      //   flutter_page_back.postMessage(this.fid + "");
      //   console.log("调用成功 1");
      // } catch (error) {
      //   console.log("调用失败 1 ：" + JSON.stringify(error));
      //   Toast("返回失败1：" + JSON.stringify(error));
      // }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
html,
body {
  height: 100%;
}
.modal-body {
  overflow: hidden;
  height: 100%;
  padding: 0;
  font-size: 14px;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB",
    "\5B8B\4F53", "Microsoft Yahei", sans-serif;
  // overflow: auto
}
.modal-body-scroll {
  overflow: auto;
  height: 100%;
}

.el-page-header {
  height: 80px;
  background: rgb(32, 148, 244);
  // display: flex;
  align-items: flex-end;
  color: #fff;
  padding: 0 10px 10px;
  box-sizing: border-box;
}
.btn {
  position: absolute;
  top: 44px;
  right: 5px;
  z-index: 999;
}
.radioBtn {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}
/deep/ .el-page-header__content {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  // margin-left: 16%;
  width: calc(100% - 188px);
  text-align: center;
}
/deep/ .el-page-header__left::after {
  display: none;
}

/deep/ .el-drawer {
  width: 70% !important;
}
.form-style {
  display: flex;
  justify-content: left;
  align-items: center;
  // margin: 10 auto;
  padding-left: 10px;
  flex-wrap: wrap;
  width: 100%;
  margin: 10px auto;
  /deep/.el-form-item {
    width: 50%;
    margin-bottom: 22px;
  }
}
/deep/.el-form-item__label {
  padding-right: 3px;
  margin-left: 0%;
}
/deep/.el-form-item__content {
  margin-left: -40px;
}
/deep/.el-form-item--mini.el-form-item {
  margin-left: -12px;
  margin-bottom: 7px;
}
/deep/.el-input--suffix .el-input__inner {
  padding-right: 10px;
  // width: max-content;
}
.icon_style {
  width: 20px;
  height: 20px;
}
/deep/.el-button--mini {
  background-color: rgb(32, 148, 244);
  border: 1px solid rgb(32, 148, 244);
}
.filter_style {
  margin-top: 6px;
  span {
    padding-left: 4px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/report/TrainBusinessReport.vue